export const ALL_SUPPLIERS = 'Tous';

/**
 * Order status for PEQ order type
 */
export enum StatusOrderMeal {
  Planned = 'PLANNED',
  Sent = 'SENT',
  Order = 'ORDER',
  OrderError = 'ORDER_ERROR',
  RegulatedSend = 'REGULATED_SEND',
  Regulated = 'REGULATED',
  RegulationError = 'REGULATION_ERROR',
}

/**
 * Endpoint list for BFF call
 */
export enum Endpoints {
  SendOrder = '/peq/orders/{orderNumber}/send',
  MailTemplates = '/peq/mail-templates',
  ReadOrdersByDayAndSupplier = '/peq/orders',
  GetSuppliersAndEmailsByCodeAndValidityRange = '/peq/get-suppliers-and-mails',
  Suppliers = '/peq/suppliers',
  OvensCsv = '/peq/ovens/csv',
  GetOvensLastUploadTimeCsv = '/peq/ovens/csv/last-upload-time',
  getDetailAircraftLoading = '/peq/orders/{orderNumber}/details/{flightNumber}/aircraftLoading',
  NewOrUpdateAircraftLoading = '/peq/orders/{orderNumber}/details/{flightNumber}',
  RefreshCalculation = '/peq/update-calcul',
  GenerateOrderSummary = '/peq/orders/{orderTechnicalId}/summary',
  ReadOrdersSummariesFromPeriod = '/peq/orders/summaries',
  CheckIfCalculatingInProgress = '/peq/orders/check-calculation',
  Compensations = '/ind/compensations',
  CompensationsDetailsByMonth = '/ind/compensations/month',
  GenerateCompensationSummary = '/ind/compensations/{idCompensation}/summary',
  TaxiDetail = '/trans/taxi-orders',
  Airports = '/trans/stopovers',
  TaxiExport = '/trans/taxi-orders/csv',
  Shuttle = '/trans/shuttles/orders',
  CarRental = '/trans/car-rental/orders',
  UpdateCarRental = '/trans/car-rental',
  CarRentalExport = '/trans/car-rental/csv',
  CarRentalLatestOrderDate = '/trans/car-rental/latest-order-date',
  HotelOrders = '/trans/hotel-orders',
  UpdatePickupOrder = '/trans/pickup-orders/update',
  ExportPickupOrders = '/trans/pickup-orders/csv',
  Hotels = '/hotels',
  HotelExport = '/trans/hotel-orders/csv',
  LogActivities = '/log/activities',
  LogActivitiesLatestHistoryDate = '/log/activities/latest-history-date',
  LogActivitiesGetPointsParameters = '/log/activities/points/parameters',
  NewActivitiesLogisticPoints = '/log/activities/points',
  LogActivitiesReservationStatus = '/log/activities/reservations',
  LogActivitiesPlanningStatus = '/log/activities/plannings',
  LogCrewMembers = '/crew-member/pns',
  LogCrewMemberActivityTransactionHistory = '/log/activities/history/{registrationNumber}',
  PickupOrders = '/trans/pickup-orders',
  UsersHop = '/log/users-hop/{registrationNumber}',
  HotelOrdersLatestHistoryDate = '/trans/hotel-orders/latest-hotel-history-date',
}

export enum Modules {
  Activity = 'activity',
  Hotel = 'hotel',
  MepPlane = 'mep-plane',
  Shuttle = 'shuttle',
  TaxiAndPickup = 'taxi-and-pickup',
  PickupsHotel = 'pickups-hotel',
  CarRental = 'car-rental',
  Train = 'train',
  MealTray = 'meal-tray',
  Compensation = 'compensation',
  LogisticPoint = 'logistic-point',
  CalculatingPoint = 'calculating-point',
  History = 'history',
  Settings = 'settings',
}
